"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheapestHotelContractRate = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const dayjs = require("dayjs");
const getCheapestHotelContractRate = (contracts, date) => {
    const activeContracts = contracts.filter((contract) => {
        // Assuming start_date and end_date are Date objects
        const currentDate = dayjs(date);
        return (dayjs(contract.start_date) <= currentDate &&
            dayjs(contract.end_date) >= currentDate);
    });
    // get the price bands whos from and to date are within the current date
    let priceBands = [];
    const rates = [];
    activeContracts.forEach((contract) => {
        if (!contract.price_bands)
            return;
        priceBands = priceBands.concat(contract.price_bands);
    });
    const currentDate = dayjs(date);
    const priceBand = priceBands.find((band) => {
        return (dayjs(band.from_date) <= currentDate && dayjs(band.to_date) >= currentDate);
    });
    // get the cheapest rate in the activecontracts.products.rates where the price_band_id is in the price bands array
    if (priceBand) {
        activeContracts.forEach((contract) => {
            if (!contract.products)
                return;
            contract.products.forEach((product) => {
                if (!product.rates)
                    return;
                product.rates.forEach((rate) => {
                    if (priceBand?.id === rate.price_band_id) {
                        rates.push({
                            ...rate,
                            currency: contract.supplier.currency,
                            contract_type: contract.type,
                        });
                    }
                });
            });
        });
        // get the cheapest rate based on cost_price
        rates.sort((a, b) => {
            return a.cost_price - b.cost_price;
        });
        if (rates.length > 0) {
            return rates[0];
        }
        return null;
    }
    return null;
};
exports.getCheapestHotelContractRate = getCheapestHotelContractRate;
